import { gql } from '@apollo/client';

export const CREATE_MESSAGE = gql`
  mutation CREATE_MESSAGE($roomId: Float!, $content: String!, $imageId: Float) {
    createMessage(roomId: $roomId, content: $content, imageId: $imageId) {
      __typename
      id
      content
      createdAt

      author {
        email
        id

        avatar {
          fileUrl
        }
      }

      image {
        id
        fileUrl
      }
    }
  }
`;
